module.exports = __webpack_public_path__ + "static/media/under4.757f5a72.png";